import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import CustomPricingTable from './CustomPricingTable';
import InteractionGuard from './guards/InteractionGuard';

export default function PricingPage() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showGuard, setShowGuard] = useState(false);

  if (showGuard) {
    return (
      <InteractionGuard
        onAuthenticated={() => setShowGuard(false)}
        onCancel={() => setShowGuard(false)}
        actionName="view pricing"
      />
    );
  }

  return (
    <div className="min-h-full py-12">
      <div className="fluid-container">
        <div className="text-center mb-12">
          <h1 className="fluid-h2 font-bold text-white mb-4">Pricing</h1>
          <p className="text-white/70 fluid-subtitle">
            Choose the plan that's right for you
          </p>
        </div>

        {!isAuthenticated && (
          <div className="mb-8 p-4 bg-blue-500/20 border border-blue-500/50 rounded-lg text-blue-400 text-center max-w-2xl mx-auto">
            <p className="mb-2">Sign in to subscribe to a plan</p>
            <button
              onClick={() => setShowGuard(true)}
              className="bg-white text-black px-6 py-2 rounded-full font-semibold hover:bg-gray-200 transition-colors"
            >
              Sign In
            </button>
          </div>
        )}

        {isAuthenticated && (
          <div className="mb-8 text-center">
            <button
              onClick={() => navigate('/checkout')}
              className="bg-white text-black px-6 py-3 rounded-full font-semibold hover:bg-gray-200 transition-colors"
            >
              Subscribe or Manage Payment
            </button>
          </div>
        )}

        <CustomPricingTable />
      </div>
    </div>
  );
}

